
import * as THREE from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {CSS2DRenderer, CSS2DObject} from 'https://threejs.org/examples/jsm/renderers/CSS2DRenderer.js';
import {fitCameraToCenteredObject} from '//www.roomix.com/cdn/shop/t/101/assets/roomix-dt-threeHelpers.js?v=67942869420348459101755106642'
import {configureModals} from '//www.roomix.com/cdn/shop/t/101/assets/roomix-dt-modals.js?v=46124804624520036031755106646'
import {configureSteps} from '//www.roomix.com/cdn/shop/t/101/assets/roomix-dt-ui.js?v=174058569954143386261755106665'
import {configurePaint, paintWallFromUrl, updatePaintSelection} from '//www.roomix.com/cdn/shop/t/101/assets/roomix-dt-paint.js?v=134698051457182919801755106646'
import {getUuidAndSessionCount} from '//www.roomix.com/cdn/shop/t/101/assets/roomix-dt-uuid.js?v=97178531256959559561755106644'
import {checkShopifyStock} from '//www.roomix.com/cdn/shop/t/101/assets/roomix-dt-shopify.js?v=137930040775289215121755106640'
import {FontLoader} from 'https://threejs.org/examples/jsm/loaders/FontLoader.js';
import {TextGeometry} from 'https://threejs.org/examples/jsm/geometries/TextGeometry.js';

// TODO: move to ui.js if it works
// Hide the loading message
const loadingMessage = document.getElementById("loading");
loadingMessage.style.display = 'none';

const newsLetterForm = document.getElementById("NewsletterForm--footer");
if (newsLetterForm) {
  newsLetterForm.classList.add("browser-default");
}

var params = {};
// Default to false in case the API call fails
params['roller-in-stock'] = false;
let imageData = null;
let dimensionLabel = [];
const url = new URL(window.location);
const urlParams = new URLSearchParams(window.location.search);

checkShopifyStock(params);
configureModals();

let wallWidth = roundToOneDecimalPlace(urlParams.get('width'))
if ((wallWidth == 0) || isNaN(wallWidth)) {
  wallWidth = 380;
}
wallWidth = wallWidth / 100;

let wallHeight = roundToOneDecimalPlace(urlParams.get('height'));
if ((wallHeight == 0) || isNaN(wallHeight)) {
  wallHeight = 220;
}
wallHeight = (wallHeight + 20) / 100;

let panelHeight = urlParams.get('panel-height');
if (panelHeight == null) {
  // If not explicitly set we're panelling the full height of the wall
  panelHeight = wallHeight;
}

// Set selected option on panel height ratios

const panelHeightRatios = document.querySelectorAll('[name="height-select"]');
for (const panelHeightRatio of panelHeightRatios) {
  if (panelHeightRatio.value === panelHeight.toString()) {
    panelHeightRatio.checked = true;
  }
}

// TODO: can we detect if it didn't match and add a custom option here?

let numberOfRows = parseInt(urlParams.get('rows'));
if (isNaN(numberOfRows)) {
  numberOfRows = null;
}

let numberOfColumns = parseInt(urlParams.get('columns'));
if (isNaN(numberOfColumns)) {
  numberOfColumns = null;
}

const {uuid, sessionCount} = getUuidAndSessionCount();
params["wall_width"] = wallWidth;
// The panelling and the wall heights includes the skirting currently
params["wall_height"] = wallHeight;
params["panel_height"] = panelHeight;
params["columns"] = numberOfColumns;
params["rows"] = numberOfRows;
params["uuid"] = uuid;
params["session_count"] = sessionCount;

const scene = new THREE.Scene();
const containerWidth = document.querySelector('#design-tool').offsetWidth;
const containerHeight = document.querySelector('#design-tool').offsetHeight;
scene.background = new THREE.Color('#F5F5F7'); // whiteish background

let windowHeight = 280;
if (window.matchMedia("(max-width: 749px)")) {
  windowHeight = containerHeight;
}


const camera = new THREE.PerspectiveCamera(75, containerWidth / windowHeight, 0.1, 1000);

const pdfHeight = 750;
const pdfWidth = 1100;
const pdfCamera = new THREE.PerspectiveCamera(75, pdfWidth / pdfHeight, 0.1, 1000);

const labelRenderer = new CSS2DRenderer();
labelRenderer.setSize(containerWidth, windowHeight);
labelRenderer.domElement.style.position = "absolute";
const container = document.getElementById('design-tool');
container.appendChild(labelRenderer.domElement);

const renderer = new THREE.WebGLRenderer({antialias: true});
renderer.setSize(containerWidth, windowHeight);
container.appendChild(renderer.domElement);

const pdfRenderer = new THREE.WebGLRenderer({antialias: true});
pdfRenderer.setSize(pdfWidth - 85, pdfHeight - 60);

// Controls (must be added to the labelRender or they won't work)
const controls = new OrbitControls(camera, labelRenderer.domElement);
controls.minPolarAngle = Math.PI / 2;
controls.maxPolarAngle = Math.PI / 2;

// Add wall
const wall_depth = 0.10; // 10 cm
const wall_geometry = new THREE.BoxGeometry(params.wall_width, params.wall_height, wall_depth);
const wall_material = new THREE.MeshPhongMaterial({color: "#f5ebe1"}); // Roomix cream
const wall = new THREE.Mesh(wall_geometry, wall_material);
wall.position.set(0, params.wall_height * -0.5, 0);
scene.add(wall);

// Update camera to fit best to wall size
updateCamera(camera, controls, wall);

// Add skirting board
const skirting_board_height = 0.2; // 20 cm
const skirting_board_depth = 0.05; // 5 cm
const skirting_board_geometry = new THREE.BoxGeometry(params.wall_width, skirting_board_height, skirting_board_depth);
skirting_board_geometry.translate(0, skirting_board_height / 2, (skirting_board_depth) / 2);
const skirting_board_material = new THREE.MeshPhongMaterial();
const skirting_board = new THREE.Mesh(skirting_board_geometry, skirting_board_material);
skirting_board.position.set(0, 0, 0);
wall.add(skirting_board);

// Plank variables
const plank_diameter = 0.1; // 10 cm
const plank_depth = 0.02; // 2 cm really Should be 0.6 cm
const ideal_panel_size = 0.5; // 50 cm
let plank_material = new THREE.MeshPhongMaterial({color: '#ce9a6f'}); // MDF colour

// Horizontal planks
let horizontal_planks = [];
let horizontal_plank_geometry = new THREE.BoxGeometry(params.wall_width, plank_diameter, plank_depth);
horizontal_plank_geometry.translate(
  0,
  (plank_diameter / 2) + skirting_board_height,
  plank_depth / 2);

const available_wall_height = getPanellingHeight(params.wall_height, params.panel_height, skirting_board_height);

// Add back panels (needed for paint colour)
const backPanelGeometry = new THREE.BoxGeometry(params.wall_width, available_wall_height, wall_depth + 0.0001);
backPanelGeometry.translate(0, (available_wall_height / 2) + skirting_board_height, (wall_depth * -1) / 2);
let backPanelMaterial = new THREE.MeshPhongMaterial({color: "#f5ebe1"});
const backPanel = new THREE.Mesh(backPanelGeometry, backPanelMaterial);
wall.add(backPanel);

let vertical_plank_geometry = new THREE.BoxGeometry(plank_diameter, available_wall_height, plank_depth);
const vertical_planks = [];
let panelHorizontalDimensions = [];
let panelVerticalDimensions = [];
let wallHorizontalDimensions = [];
let wallVerticalDimensions = [];
let wallDimensions = [];

configureSteps(url, wall, skirting_board, params);
// Sets initial paint options to popular paints
updatePaintSelection(1);
configurePaint(wall, skirting_board, backPanel, updatePlankMaterial);
paintWallFromUrl(wall, skirting_board, backPanel, updatePlankMaterial);

// Only auto-calculate the numbers of rows and cols if they haven't been set
if ((numberOfRows == null) || (numberOfColumns == null)) {
  redrawWall(true);
} else {
  redrawWall(false);
}

// Add some light
const color = 0xFFFFFF;
const intensity = 0.60;
const lightDistance = 0; // Infinite distance https://threejs.org/docs/#api/en/lights/PointLight
const lightDecay = 5.0;
const light = new THREE.PointLight(color, intensity, lightDistance, lightDecay);
light.position.set(1, 3, 3);
scene.add(light);
const alight = new THREE.AmbientLight(0xFFFFFF, 0.40);
scene.add(alight);

function updatePlankMaterial(paintHex) {
  plank_material = new THREE.MeshPhongMaterial({color: paintHex});
}

function updateCamera(camera, controls, wall) {
  fitCameraToCenteredObject(camera, wall, 1.2, controls);
  // TODO: check we need this
  fitCameraToCenteredObject(pdfCamera, wall, 1.2, controls);
}

function calcAndAddPanelHorizontalDimensions(scene, wall, columns, plank_diameter, skirting_board) {
  const panelWidth = getPanelWidth(wall, columns, plank_diameter);
  panelHorizontalDimensions = addPanelHorizontalDimensions(scene, wall, skirting_board, panelWidth, plank_diameter);
}

function round(value, precision) {
  // https://stackoverflow.com/questions/7342957/how-do-you-round-to-1-decimal-place-in-javascript
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

function addPanelHorizontalDimensions(scene, wall, skirtingBoard, panelWidth, plankDiameter) {
  const skirtingBoardHeight = skirtingBoard.geometry.parameters.height;
  const wallWidth = wall.geometry.parameters.width;
  const wallHeight = wall.geometry.parameters.height;
  const dir = new THREE.Vector3(1, 0, 0);
  const x = ((wallWidth / 2) * -1) + plankDiameter;
  const y = skirtingBoardHeight + plankDiameter - (wallHeight / 2);
  const origin = new THREE.Vector3(x, y, 0.01);
  // Vector for drawing the arrow pointing the opposite way
  const vector = new THREE.Vector3(panelWidth, 0, 0)
  const arrows = drawArrows(scene, dir, origin, panelWidth, vector);

  // TODO: why is this the X offset rather than the y?
  const labelX = 0;
  // TODO: why is the Y offset rather than the x?
  const labelY = (panelWidth / 2);
  const labelZ = 0;
  const labelText = round(panelWidth * 100, 1) + " cm";
  // Offset slightly to the right and below the arrow
  const labelVector = new THREE.Vector3(
    arrows[0].position.x + 0.1,
    arrows[0].position.y - 0.125,
    arrows[0].position.z + 0.1) /* Place in front of skirting */
  dimensionLabel[1] = {'text': labelText, 'vector': labelVector};
  drawLabel(arrows[0], labelText, labelX, labelY, labelZ, "label panel-horizonal-label");
  return arrows;
}

function calcAndAddPanelVerticalDimensions(scene, wall, rows, plank_diameter, skirting_board) {
  const panelHeight = getPanelHeight(wall, rows, plank_diameter, skirting_board);
  panelVerticalDimensions = addPanelVerticalDimensions(scene, wall, skirting_board, panelHeight, plank_diameter);
}

function addPanelVerticalDimensions(scene, wall, skirtingBoard, panelHeight, plankDiameter) {
  const dir = new THREE.Vector3(0, 1, 0);
  const skirtingBoardHeight = skirtingBoard.geometry.parameters.height;
  const wallWidth = wall.geometry.parameters.width;
  const wallHeight = wall.geometry.parameters.height;
  const x = ((wallWidth / 2) * -1) + plankDiameter;
  const y = skirtingBoardHeight + plankDiameter - (wallHeight / 2);
  // TODO: use variable to represent the 0.01 depth (z value)
  const origin = new THREE.Vector3(x, y, 0.01);
  const vector = new THREE.Vector3(0, panelHeight, 0);
  const items = drawArrows(scene, dir, origin, panelHeight, vector);

  const labelX = 0;
  const labelY = (panelHeight / 2);
  const labelZ = 0;
  // TODO: round to 1 decimal place?
  const labelText = round(panelHeight * 100, 1) + " cm";
  // Offset slightly to the right and up
  // Ideally we should calc the middle of the arrow/panel for how far up
  const labelVector = new THREE.Vector3(
    items[0].position.x + 0.05,
    items[0].position.y + 0.25,
    items[0].position.z)
  dimensionLabel[0] = {'text': labelText, 'vector': labelVector};
  drawLabel(items[0], labelText, labelX, labelY, labelZ, "label panel-label");
  return items;
}


function addWallDimensions(scene, wall, skirtingBoard) {
  var h = addWallHorizonalDimensions(scene, wall);
  var v = addWallVerticalDimensions(scene, wall, skirtingBoard);
  return [h, v];
}


function addWallVerticalDimensions(scene, wall, skirtingBoard) {
  const dir = new THREE.Vector3(0, 1, 0);
  const wallHeight = wall.geometry.parameters.height;
  const wallWidth = wall.geometry.parameters.width;
  const skirtingBoardHeight = skirtingBoard.geometry.parameters.height;
  // is the 0.1 the skirting board divided by 2? Make this clear in the code
  const x = ((wallWidth / 2) * -1) - 0.1;
  const y = skirtingBoardHeight - (wallHeight / 2);
  // offset the arrow 10 cm to the left of the wall
  // TODO: use variable to represent this
  const origin = new THREE.Vector3(x, y, 0.01);
  const length = wallHeight - skirtingBoardHeight;
  const vector = new THREE.Vector3(0, length, 0);
  const arrows = drawArrows(scene, dir, origin, length, vector);

  const labelX = 0;
  const labelY = (wallHeight - skirtingBoardHeight) / 2;
  const labelZ = 0;
  const labelText = round(length * 100, 1) + " cm";
  // Shift to the right of the arrow and place in the centre
  const labelVector = new THREE.Vector3(
    arrows[0].position.x - 0.2,
    arrows[0].position.y + (length / 2),
    arrows[0].position.z);
  dimensionLabel[2] = {'text': labelText, 'vector': labelVector};
  drawLabel(arrows[0], labelText, labelX, labelY, labelZ, 'label wall-label');
  return arrows;
}


function addWallHorizonalDimensions(scene, wall) {
  const dir = new THREE.Vector3(1, 0, 0);
  const wallWidth = wall.geometry.parameters.width;
  const wallHeight = wall.geometry.parameters.height;
  const x = (wallWidth / 2) * -1;
  const y = -0.1 - (wallHeight / 2);
  const origin = new THREE.Vector3(x, y, 0.01);
  // Vector for drawing the arrow pointing the opposite way
  const vector = new THREE.Vector3(wallWidth, 0, 0)
  const arrows = drawArrows(scene, dir, origin, wallWidth, vector);
  const labelX = 0;
  const labelY = (wallWidth / 2);
  const labelZ = 0;
  const labelText = round(wallWidth * 100, 1) + " cm";
  const labelVector = new THREE.Vector3(
    arrows[0].position.x + labelY,
    arrows[0].position.y - 0.1,
    arrows[0].position.z);
  dimensionLabel[3] = {'text': labelText, 'vector': labelVector};
  drawLabel(arrows[0], labelText, labelX, labelY, labelZ, 'label wall-label');
  return arrows;
}


function drawArrows(scene, dir, origin, length, vector) {
  const hex = '#000000'; // black
  const headLength = 0.04;
  const headWidth = 0.04;
  const arrow = new THREE.ArrowHelper(dir, origin, length, hex, headLength, headWidth);
  let origin2 = origin.clone().add(vector);
  const arrow2 = new THREE.ArrowHelper(dir.negate(), origin2, length, hex, headLength, headWidth);
  scene.add(arrow);
  // TODO: could we add arrow2 to arrow?
  scene.add(arrow2);
  return [arrow, arrow2];
}


function drawLabel(item, text, x, y, z, cssClass = "label") {
  const div = document.createElement("div");
  div.className = cssClass;
  div.textContent = text;
  const label = new CSS2DObject(div);
  label.position.set(x, y, z);
  item.add(label);
  return label;
}


function calcNumberRows(available_wall_height, plank_diameter, ideal_panel_size) {
  const available_wall_height_cm = available_wall_height * 100;
  const plank_diameter_cm = plank_diameter * 100;
  const ideal_panel_size_cm = ideal_panel_size * 100;
  const number_of_panels = Math.round((available_wall_height_cm - plank_diameter_cm) / (ideal_panel_size_cm + plank_diameter_cm));
  return number_of_panels;
}


function updateNumberOfColumns(numberOfPanels) {
  document.getElementById("number-of-columns").textContent = numberOfPanels;
  params.columns = numberOfPanels;
}

function updateNumberOfRows(numberOfPanels) {
  document.getElementById("number-of-rows").textContent = numberOfPanels;
  params.rows = numberOfPanels;
}

function calcAndAddVerticalPlanks(wall, vertical_planks, plank_diameter, ideal_panel_size) {
  // TODO: pass in plank as an argument, rename to vertical plank
  // TODO: this block should be one (ideally unit tested) function
  const wall_width = wall.geometry.parameters.width;
  const wall_width_cm = wall_width * 100;
  const plank_diameter_cm = plank_diameter * 100;
  const ideal_panel_size_cm = ideal_panel_size * 100;
  const number_of_panels = Math.round((wall_width_cm - plank_diameter_cm) / (ideal_panel_size_cm + plank_diameter_cm));
  updateNumberOfColumns(number_of_panels);

  // TODO: is it simpler to deal with a panel_and_plank_width variable?
  const panel_width = ((wall_width - plank_diameter) / number_of_panels) - plank_diameter;
  addVerticalPlanks(wall, vertical_planks, number_of_panels, panel_width, plank_diameter);
  // TODO: would it be cleaner to return the vertical_planks? Feels a better design
}


function calcAndAddHorizontalPlanks(wall, skirtingBoard, plankDiameter, idealPanelSize) {
  const availableWallHeight = getPanellingHeight(wall.geometry.parameters.height, params.panel_height, skirtingBoard.geometry.parameters.height)
  const numberOfRows = calcNumberRows(availableWallHeight, plankDiameter, idealPanelSize);
  updateNumberOfRows(numberOfRows);
  horizontal_planks = addHorizontalPlanks(wall, numberOfRows, plankDiameter, skirtingBoard);
  return numberOfRows;
}


function getPanelWidth(wall, number_of_columns, plank_diameter) {
  const wall_width = wall.geometry.parameters.width;
  const combined_width = (wall_width - plank_diameter) / number_of_columns;
  return combined_width - plank_diameter;
}


function getPanelHeight(wall, numberOfPanels, plankDiameter, skirtingBoard) {
  const availableWallHeight = getPanellingHeight(
    wall.geometry.parameters.height,
    params.panel_height,
    skirtingBoard.geometry.parameters.height);
  return (availableWallHeight - ((numberOfPanels + 1) * plankDiameter)) / numberOfPanels;
}


function addHorizontalPlanks(wall, number_of_panels, plank_diameter, skirtingBoard) {
  let planks = [];
  let panel_height = getPanelHeight(wall, number_of_panels, plank_diameter, skirtingBoard);
  // Start at zero and equal the number of panels so we get the last panel
  for (let n = 0; n <= number_of_panels; n++) {
    const y_position = (panel_height + plank_diameter) * n;
    let plank = addHorizontalPlank(wall, y_position);
    planks.push(plank);
  }
  return planks;
}


function addHorizontalPlank(wall, y_position) {
  // TODO: could plank be an argument that we clone? If done like this it could be a shared addPlank(x, y) function
  // TODO: vertical_plank_geometry and plank_material aren't passed in should plank be an argument
  const plank = new THREE.Mesh(horizontal_plank_geometry, plank_material);
  plank.position.set(0, y_position, 0);
  wall.add(plank);
  return plank;
}


function addVerticalPlanks(wall, vertical_planks, number_of_panels, panel_width, plank_diameter) {
  // Start at zero and equal the number of panels so we get the last panel
  for (let n = 0; n <= number_of_panels; n++) {
    const x_position = (panel_width + plank_diameter) * n;
    addVerticalPlank(wall, vertical_planks, x_position);
  }
}

function addVerticalPlank(wall, vertical_planks, x_position) {
  // TODO: vertical_plank_geometry and plank_material aren't passed in should plank be an argument
  const plank = new THREE.Mesh(vertical_plank_geometry, plank_material);
  plank.position.set(x_position, 0, 0);
  vertical_planks.push(plank);
  wall.add(plank);
}

function removePlanks(wall, planks) {
  for (const plank of planks) {
    wall.remove(plank);
  }
}

function removeDimensions(elements, querySelector) {
  for (const element of elements) {
    scene.remove(element);
  }
  const domElement = document.querySelector(querySelector);
  if (domElement) {
    domElement.remove();
  }
}

function getPanellingHeight(wallHeight, panelHeight, skirtingBoardHeight) {
  if (panelHeight < wallHeight) {
    return panelHeight - skirtingBoardHeight;
  }
  return wallHeight - skirtingBoardHeight;
}

// TODO: rework to use parameters
function redrawWall(calcRowsAndColumns) {
  let new_geometry = new THREE.BoxGeometry(params.wall_width, params.wall_height, wall_depth);
  new_geometry.translate(0, params.wall_height / 2, (wall_depth * -1) / 2);
  wall_geometry.dispose();
  wall.geometry = new_geometry;

  // Needed for when wall height changes
  wall.position.set(0, (params.wall_height / 2) * -1, 0);
  // console.log(wall.position);

  let new_skirting_board_geometry = new THREE.BoxGeometry(params.wall_width, skirting_board_height, skirting_board_depth);
  new_skirting_board_geometry.translate(0, skirting_board_height / 2, (skirting_board_depth) / 2);
  skirting_board_geometry.dispose();
  skirting_board.geometry = new_skirting_board_geometry;

  const panellingHeight = getPanellingHeight(params.wall_height, params.panel_height, skirting_board_height);
  // NOTE: Depth is bumped by 0.0001 to stop strange rendering on rotate
  const newBackPanelGeometry = new THREE.BoxGeometry(params.wall_width, panellingHeight, wall_depth + 0.0001);
  newBackPanelGeometry.translate(0, (panellingHeight / 2) + skirting_board_height, (wall_depth * -1) / 2);
  backPanelGeometry.dispose();
  backPanel.geometry = newBackPanelGeometry;

  // The vertical plank geometry must match the new wall size
  vertical_plank_geometry = new THREE.BoxGeometry(plank_diameter, panellingHeight, plank_depth);
  const verticalPlankX = (params.wall_width / 2) * -1 + (plank_diameter / 2);
  const panelHeightDifference = params.wall_height - panellingHeight;
  const verticalPlankY = (params.wall_height / 2) - (panelHeightDifference / 2) + (skirting_board_height / 2);
  const verticalPlankZ = plank_depth / 2;
  vertical_plank_geometry.translate(
    verticalPlankX,
    verticalPlankY,
    verticalPlankZ);

  // The horizontal plank geometry must match the new wall size
  horizontal_plank_geometry = new THREE.BoxGeometry(params.wall_width, plank_diameter, plank_depth);
  horizontal_plank_geometry.translate(
    0,
    (plank_diameter / 2) + skirting_board_height,
    plank_depth / 2);

  removePlanks(wall, horizontal_planks);
  removePlanks(wall, vertical_planks);
  if (calcRowsAndColumns) {
    calcAndAddHorizontalPlanks(wall, skirting_board, plank_diameter, ideal_panel_size);
    calcAndAddVerticalPlanks(wall, vertical_planks, plank_diameter, ideal_panel_size);
  } else {
    horizontal_planks = addHorizontalPlanks(wall, params.rows, plank_diameter, skirting_board);
    updateNumberOfRows(params.rows);

    const wall_width = wall.geometry.parameters.width;
    const panel_width = ((wall_width - plank_diameter) / params.columns) - plank_diameter;
    addVerticalPlanks(wall, vertical_planks, params.columns, panel_width, plank_diameter);
    updateNumberOfColumns(params.columns);
  }

  removeDimensions(panelHorizontalDimensions, '.panel-horizonal-label');
  removeDimensions(panelVerticalDimensions, '.panel-label');
  removeDimensions(wallHorizontalDimensions, '.label');
  removeDimensions(wallVerticalDimensions, '.label');

  // Do we not need the variable assignment here? Why not?
  calcAndAddPanelVerticalDimensions(scene, wall, params.rows, plank_diameter, skirting_board);
  calcAndAddPanelHorizontalDimensions(scene, wall, params.columns, plank_diameter, skirting_board);
  wallDimensions = addWallDimensions(scene, wall, skirting_board);
  wallHorizontalDimensions = wallDimensions[0];
  wallVerticalDimensions = wallDimensions[1];
}


function startDownload() {
  let loader = new FontLoader();
  // TODO: Store font local?
  loader.load('https://unpkg.com/three@0.77.0/examples/fonts/helvetiker_bold.typeface.json', function (font) {
    let pdfScene = scene.clone();
    pdfScene.background = new THREE.Color('#FFFFFF');
    const textMaterial = new THREE.MeshBasicMaterial({color: 0x000000});
    for (var i = 0; i < dimensionLabel.length; i++) {
      let textGeo = new TextGeometry(dimensionLabel[i]['text'], {
        font: font,
        size: 0.08,
        height: 0,
        curveSegments: 20, // Lower makes it more angular
        bevelEnabled: false,
      });
      textGeo.computeBoundingBox();
      let mesh = new THREE.Mesh(textGeo, textMaterial);
      mesh.position.x = dimensionLabel[i]['vector'].x;
      mesh.position.y = dimensionLabel[i]['vector'].y;
      mesh.position.z = dimensionLabel[i]['vector'].z;
      mesh.castShadow = false;
      mesh.receiveShadow = false;
      pdfScene.add(mesh);
    }
    pdfRenderer.render(pdfScene, pdfCamera);

    const pdf = new jsPDF({'orientation': 'l'});
    const imgData = pdfRenderer.domElement.toDataURL("image/jpeg", 1.0);
    pdf.addImage(imgData, 'JPEG', 15, 15);
    // TODO? Should header be forced for download here?
    pdf.save("roomix.pdf");
  });
}

function animate() {
  requestAnimationFrame(animate);
  renderer.render(scene, camera);
  labelRenderer.render(scene, camera);
  // TODO: Does it need to be called every animate frame?
  pdfRenderer.render(scene, pdfCamera);
}

animate();

const download = urlParams.get('download')
if (download == '1') {
  startDownload();
}

const hideLabels = document.querySelectorAll(".menu-drawer-container");
// console.log(hideLabels);
if (hideLabels.length >= 1) {
  const labels = document.querySelectorAll('.label');
  hideLabels[0].addEventListener('click', function (event) {
    for (const label of labels) {
      if (label.style.visibility == "hidden") {
        label.style.visibility = '';
      } else {
        label.style.visibility = 'hidden';
      }
    }
  });
}

function updateRows(action) {
  const numberOfRowsElement = document.getElementById('number-of-rows').firstChild;
  let numberOfRows = parseInt(numberOfRowsElement.nodeValue);

  if ((action === 'plus' && numberOfRows < 9) || (action === 'minus' && numberOfRows > 1)) {
    numberOfRows += (action === 'plus') ? 1 : -1;
    numberOfRowsElement.nodeValue = numberOfRows;
    params.rows = numberOfRows;

    removePlanks(wall, horizontal_planks);
    horizontal_planks = addHorizontalPlanks(wall, numberOfRows, plank_diameter, skirting_board);
    removeDimensions(panelVerticalDimensions, '.panel-label');
    calcAndAddPanelVerticalDimensions(scene, wall, numberOfRows, plank_diameter, skirting_board);
    updateUrlRowsAndColumns(url, params);
  }
}

const clickMe = document.getElementById('rows-plus');
clickMe.addEventListener('click', function (event) {
  updateRows('plus');
});

const clickMeMinus = document.getElementById('rows-minus');
clickMeMinus.addEventListener('click', function (event) {
  updateRows('minus');
});

const clickMeCol = document.getElementById('columns-plus');
clickMeCol.addEventListener('click', function (event) {
  const numberOfColumnsElement = document.getElementById('number-of-columns').firstChild;
  let numberOfColumns = parseInt(numberOfColumnsElement.nodeValue);

  if (numberOfColumns < 30) {
    numberOfColumns++;
    numberOfColumnsElement.nodeValue = numberOfColumns;
    params.columns = numberOfColumns;

    const panelWidth = getPanelWidth(wall, numberOfColumns, plank_diameter);
    removePlanks(wall, vertical_planks);
    addVerticalPlanks(wall, vertical_planks, numberOfColumns, panelWidth, plank_diameter);

    removeDimensions(panelHorizontalDimensions, '.panel-horizonal-label');
    calcAndAddPanelHorizontalDimensions(scene, wall, numberOfColumns, plank_diameter, skirting_board);
    updateUrlRowsAndColumns(url, params);
  }
});

const clickMeColMinus = document.getElementById('columns-minus');
clickMeColMinus.addEventListener('click', function (event) {
  const numberOfColumnsElement = document.getElementById('number-of-columns').firstChild;
  let numberOfColumns = parseInt(numberOfColumnsElement.nodeValue);

  if (numberOfColumns > 1) {
    numberOfColumns--;
    numberOfColumnsElement.nodeValue = numberOfColumns;
    params.columns = numberOfColumns;

    const panelWidth = getPanelWidth(wall, numberOfColumns, plank_diameter);
    removePlanks(wall, vertical_planks);
    addVerticalPlanks(wall, vertical_planks, numberOfColumns, panelWidth, plank_diameter);

    removeDimensions(panelHorizontalDimensions, '.panel-horizonal-label');
    calcAndAddPanelHorizontalDimensions(scene, wall, numberOfColumns, plank_diameter, skirting_board);
    updateUrlRowsAndColumns(url, params);
  }
});

function updateUrlRowsAndColumns(url, params) {
  url.searchParams.set('rows', params.rows);
  url.searchParams.set('columns', params.columns);
  window.history.pushState(null, '', url.toString());
}

document.addEventListener('input', function (event) {
  if (event.target.id == 'paint-filter-select') {
    updatePaintSelection(event.target.value);
    // Need to add event listener for the new options
    configurePaint(wall, skirting_board, backPanel, updatePlankMaterial)
  }
  if (event.target.name === 'height-select') {
    params.panel_height = event.target.value;
    redrawWall(true);
    let panelHeight = event.target.value;
    url.searchParams.set('panel-height', panelHeight);
    window.history.pushState(null, '', url.toString());
  }
  return;
}, false);

/**
 * Rounding is required or we hit bugs with converting floats to integers
 * Known to happens for 251 and 402
 */
function roundToOneDecimalPlace(x) {
  return Math.round(x * 10) / 10;
}

const widthInput = document.getElementById('wall-width');
widthInput.value = roundToOneDecimalPlace(params.wall_width * 100);
// Listen for "input" instead of "change" if we want it to change straight away
widthInput.addEventListener('change', function (event) {
  params.wall_width = event.target.value / 100;
  let width = roundToOneDecimalPlace(params.wall_width * 100);
  url.searchParams.set('width', width);
  window.history.pushState(null, '', url.toString());

  redrawWall(true);
  updateCamera(camera, controls, wall);
});

// plus minus to any input field
const eventChange = new Event('change');
function updateInputField(action, inputId, minValue, maxValue) {
  const inputElement = document.getElementById(inputId);
  let currentValue = parseInt(inputElement.value);

  if ((action === 'plus' && currentValue < maxValue) || (action === 'minus' && currentValue > minValue)) {
    currentValue += (action === 'plus') ? 1 : -1;
    inputElement.value = currentValue;
    inputElement.dispatchEvent(eventChange)
  }
}

const plusWidthButton = document.getElementById('wall-width-plus');
plusWidthButton.addEventListener('click', function (event) {
  updateInputField('plus', 'wall-width', 100, 1200);
});

const minusWidthButton = document.getElementById('wall-width-minus');
minusWidthButton.addEventListener('click', function (event) {
  updateInputField('minus', 'wall-width', 100, 1200);
});

const plusHeightButton = document.getElementById('wall-height-plus');
plusHeightButton.addEventListener('click', function (event) {
  updateInputField('plus', 'wall-height', 100, 500);
});

const minusHeightButton = document.getElementById('wall-height-minus');
minusHeightButton.addEventListener('click', function (event) {
  updateInputField('minus', 'wall-height', 100, 500);
});

const heightInput = document.getElementById('wall-height');
heightInput.value = roundToOneDecimalPlace((wallHeight * 100) - 20);
heightInput.addEventListener('change', function (event) {
  // TODO: remove duplicated logic
  params.wall_height = (event.target.value / 100) + 0.2;
  params.panel_height = params.wall_height;
  let height = roundToOneDecimalPlace((params.wall_height * 100) - 20);
  url.searchParams.set('height', height);
  window.history.pushState(null, '', url.toString());

  redrawWall(true);
  updateCamera(camera, controls, wall);
});